interface AIActionCardProps {
  action: string;
  description: string;
  params: Record<string, any>;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function AIActionCard({ action, description, params, onConfirm, onCancel }: AIActionCardProps) {
  const actionLabels: Record<string, string> = {
    create_campaign: 'Create Campaign',
    create_segment: 'Create Segment',
    create_workflow: 'Create Workflow',
    schedule_campaign: 'Schedule Campaign',
    send_test_email: 'Send Test Email',
    add_contacts: 'Add Contacts',
    update_campaign: 'Update Campaign',
  };

  return (
    <div className="my-4 bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 rounded-xl p-4">
      <div className="flex items-start gap-3">
        <div className="flex-shrink-0 w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center">
          <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
          </svg>
        </div>
        <div className="flex-1 min-w-0">
          <h4 className="text-sm font-semibold text-gray-900">
            {actionLabels[action] || action}
          </h4>
          <p className="text-sm text-gray-600 mt-1">{description}</p>
          {Object.keys(params).length > 0 && (
            <div className="mt-2 bg-white rounded-lg p-3 border border-blue-100">
              <dl className="space-y-1">
                {Object.entries(params).slice(0, 4).map(([key, value]) => (
                  <div key={key} className="flex text-xs">
                    <dt className="text-gray-500 capitalize w-24 flex-shrink-0">{key}:</dt>
                    <dd className="text-gray-900 truncate">{String(value)}</dd>
                  </div>
                ))}
              </dl>
            </div>
          )}
          <div className="flex gap-2 mt-3">
            <button
              onClick={onConfirm}
              className="px-4 py-1.5 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700"
            >
              Confirm & Execute
            </button>
            <button
              onClick={onCancel}
              className="px-4 py-1.5 text-gray-600 text-sm font-medium rounded-lg hover:bg-gray-100"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
